import React, { useState, useEffect } from "react";
import MedecinDataService from "../services/medecin.service";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { iconMap } from '../utils/iconMap';
import { useAuth0 } from '@auth0/auth0-react';

const HomeMed = () => {
  const { getAccessTokenSilently, user } = useAuth0();
  
  const [state, setState] = useState({
    trdv: [],
    weekDay: {"1":"Dimanche","2":"Lundi","3":"Mardi","4":"Mercredi","5":"Jeudi","6":"Vendredi","7":"Samedi"},
    weekDay2: {"1":"Dim","2":"Lun","3":"Mar","4":"Mer","5":"Jeu","6":"Ven","7":"Sam"},
    months: {"01":"Janvier","02":"Février","03":"Mars","04":"Avril","05":"Mai","06":"Juin","07":"Juillet","08":"Août","09":"Septembre","10":"Octobre","11":"Novembre","12":"Décembre"}
  });

  const getMedRdv = async () => {
    try {
      const response = await MedecinDataService.medrdv(user.email);
      setState(prev => ({
        ...prev,
        trdv: response.data
      }));
    } catch (e) {
      console.error("Erreur lors de la récupération des rendez-vous:", e);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email"
        });
        
        // Configurer le token pour axios
        const http = require("../http-common").default;
        http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        getMedRdv();
      } catch (error) {
        console.error('Erreur récupération token:', error);
      }
    };

    if (user?.email) {
      fetchData();
    }
  }, [user?.email, getAccessTokenSilently]);

  // Méthode pour rendre la cellule de statut
  const renderStatutCell = (appointment) => {
    const statutLibelle = appointment.statut_rdv.split("_")[1];
    const statutStyle = appointment.statut_rdv.split("_")[0];
    const statutIcone = appointment.statut_rdv.split("_")[2];
    const statutTime = appointment.statut_rdv.split("_")[3];
    
    switch (statutLibelle) {
      case 'Manqué':
        return (
          <td className={statutStyle}>
            <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
            <span title={"Rendez-vous " + statutLibelle.toLowerCase()}>{statutLibelle}</span>
          </td>
        );
      case 'En attente':
        return (
          <td className={statutStyle}>
            <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
            <span title={"Rendez-vous " + statutLibelle.toLowerCase()}>{statutLibelle}</span>
          </td>
        );
      default:
        return (
          <td className={statutStyle}>
            <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
            <span title={"Rendez-vous " + statutLibelle.toLowerCase() + (statutTime ? " le " + statutTime : '')}>
              {statutLibelle}
            </span>
          </td>
        );
    }
  };

  const { trdv, weekDay, weekDay2, months } = state;

  return (
    <div className="col-md-12 mx-auto">
      <table style={{width:"100%"}}>
        <tbody>
          <tr style={{backgroundColor:"#6f42c1"}}>
            <td style={{padding:"10px"}}>
              <table style={{color:"white"}}>
                <tbody>
                  <tr>
                    <td style={{padding:"5px"}}>
                      <FontAwesomeIcon icon={solid('calendar-days')} size="2x"/>
                    </td>
                    <td style={{padding:"5px"}}>
                      <span style={{fontSize:"1.5rem"}} className="lead"><b>Liste des rendez-vous (vue médecin)</b></span><br/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="col-md-12 mx-auto" style={{padding:"10px"}}>
        <nav id="navbar-example2" className="navbar bg-body-tertiary px-3 mb-3">
          <ul className="nav nav-pills">
            <li className="nav-item">
              <a className="nav-link" href="#aujourdhui">Aujourd'hui</a>
            </li>
          </ul>
        </nav>
        <table className="table table-hover table-striped">
          <thead>
            <tr>
              <th>Date</th>
              <th>Plage</th>
              <th>Lieu</th>
              <th>Patient</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {trdv && trdv.map((appointment, index) => {
              if(appointment.drdv2 !== trdv[index - 1]?.drdv2 && appointment.drdv2 === new Date().toISOString().split('T')[0]) {
                return (
                  <tr id="aujourdhui" key={index}>
                    <td>{appointment.drdv}</td>
                    <td>{appointment.hdeb + ' - ' + appointment.hfin}</td>
                    <td>{appointment.libelle_structure}</td>
                    <td>{appointment.nom + ' ' + appointment.prenom}</td>
                    {renderStatutCell(appointment)}
                  </tr>
                );
              } else {
                return (
                  <tr key={index}>
                    <td>{appointment.drdv}</td>
                    <td>{appointment.hdeb + ' - ' + appointment.hfin}</td>
                    <td>{appointment.libelle_structure}</td>
                    <td>{appointment.nom + ' ' + appointment.prenom}</td>
                    {renderStatutCell(appointment)}
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HomeMed;